module.exports = __webpack_public_path__ + "media/images/game/bonus_tasks/internet-b41718ef4d571278e125b1fe418b1950.png";